export default "__VITE_ASSET__R06hNGE7__"